import * as React from 'react';
import DropdownStore from './dropdown_store';

const OPEN_BUFFER_TIME = 100;
const CLOSE_BUFFER_TIME = 400;

export default (Component, name) => {
  const wrapped = class Wrapped extends React.Component {
    static displayName = `hoverDropdown(${name})`;
    static WrappedComponent = Component;

    constructor() {
      super();

      this.state = {
        hovering: false,
        isOpen: false,
      };

      this.handleClose = this.handleClose.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentDidMount() {
      DropdownStore.listen(this.handleClose);
    }

    componentWillUnmount() {
      DropdownStore.unlisten(this.handleClose);
    }

    handleMouseEnter() {
      this.setState({ hovering: true });

      setTimeout(() => {
        if (this.state.hovering) {
          DropdownStore.closeAll();

          this.setState({ isOpen: true });
        }
      }, OPEN_BUFFER_TIME);
    }

    handleMouseLeave() {
      this.setState({ hovering: false });

      setTimeout(() => {
        if (!this.state.hovering) {
          this.setState({ isOpen: false });
        }
      }, CLOSE_BUFFER_TIME);
    }

    handleClose() {
      this.setState({ isOpen: false });
    }

    render() {
      return (
        <Component
          {...this.props}
          isOpen={this.state.isOpen}
          handleClose={this.handleClose}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
      );
    }
  };

  return wrapped;
};



// WEBPACK FOOTER //
// ./javascripts/components/header/hover_dropdown.jsx